/**
 * Tiny inline-SVG sparkline. Avoids a heavy chart dep.
 *
 * Props:
 *   data        — array of numbers (already aggregated, one per bucket)
 *   width/height
 *   strokeColor
 *   fillColor   — gradient under the line; if undefined, no fill
 */
export default function Sparkline({
  data = [],
  width = 120,
  height = 30,
  strokeColor = "currentColor",
  fillColor,
  testid,
}) {
  if (!data.length) {
    return <svg width={width} height={height} data-testid={testid} aria-hidden="true" />;
  }
  const max = Math.max(...data, 1);
  const min = 0;
  const range = max - min || 1;
  const step = data.length > 1 ? width / (data.length - 1) : width;
  const points = data.map((v, i) => {
    const x = i * step;
    const y = height - ((v - min) / range) * (height - 2) - 1;
    return [x, y];
  });
  const lineD = points.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`).join(" ");
  const fillD = `${lineD} L${(points[points.length - 1][0]).toFixed(2)},${height} L0,${height} Z`;
  return (
    <svg width={width} height={height} data-testid={testid} aria-hidden="true">
      {fillColor && <path d={fillD} fill={fillColor} opacity="0.18" />}
      <path d={lineD} fill="none" stroke={strokeColor} strokeWidth="1.5" />
    </svg>
  );
}
